import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import NewsCard from '../components/NewsCard';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const CategoryPage = () => {
  const { category } = useParams();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryInfo, setCategoryInfo] = useState(null);

  useEffect(() => {
    fetchArticles();
    fetchCategoryInfo();
  }, [category]);

  const fetchArticles = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/api/articles?category=${encodeURIComponent(category)}&limit=50`);
      setArticles(response.data);
    } catch (error) {
      console.error('Failed to fetch articles:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategoryInfo = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/categories`);
      const cat = response.data.categories.find(c => c.bengali === category);
      setCategoryInfo(cat);
    } catch (error) {
      console.error('Failed to fetch category info:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      {/* Category Header */}
      <div className="bg-gradient-to-r from-red-700 to-red-600 text-white py-8">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">
            {category}
          </h1>
          {categoryInfo && (
            <p className="text-red-100 text-lg">
              {categoryInfo.english}
            </p>
          )}
        </div>
      </div>

      <div className="container mx-auto px-4 py-8">
        {loading ? (
          <div className="text-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading articles...</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Content */}
            <div className="lg:col-span-2">
              {articles.length === 0 ? (
                <div className="text-center py-20">
                  <p className="text-gray-500 text-lg">এই বিভাগে কোনো সংবাদ নেই</p>
                  <p className="text-gray-400">No articles found in this category</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {articles.map((article) => (
                    <NewsCard key={article.id} article={article} />
                  ))}
                </div>
              )}
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-1">
              <Sidebar />
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default CategoryPage;
